import axios from './axiosConfig'

export const getBannerById = async (id) => {
  const response = await axios.get(`/banner/${id}`)
  console.log('response at api', response.data)
  return response.data
}

export const updateBanner = async (id, formdata) => {
  const data = new FormData()

  // Handle image data - could be FileList or existing image URL
  if (formdata.image && formdata.image[0]) {
    data.append('image', formdata.image[0])
  }
  // console.log()

  const response = await axios.put(`/banner/${id}`, data, {
    withCredentials: true,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

  return response.data
}
